module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-item-3-f43f55768dfe057dbaf637596f9473d6.jpg";